import { useTranslation } from "react-i18next";
import { Error } from "~/components/icon/error";
import { Button } from "~/components/button";
import { Text } from "~/components/text";

export function ContactUsError() {
  const { t } = useTranslation(["contactUs", "error"]);
  return (
    <div className="w-full min-h-[50vh] pt-24 flex justify-center items-center">
      <div className="pb-4 flex flex-col items-center text-center gap-6 max-w-lg">
        <div className="mb-4">
          <Error />
        </div>

        <Text variant="pageHeading" className="pb-1">
          {t("error.title")}
        </Text>
        <Text variant="subtle">{t("error.description")}</Text>
        <a href="mailto:reedy.support@chaptr.com" data-testid="support-action">
          <Button
            label={t("error:actions.support")}
            variant="tertiary"
            size="small"
            className="text-sm!"
          />
        </a>
      </div>
    </div>
  );
}
